var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduledNotificationSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f6d6e",
    fillRule: "nonzero",
    d: "M20 10c2.652 0 5.196 1.054 7.071 2.929C28.946 14.804 30 17.348 30 20c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10zm0 1.695c-4.587 0-8.305 3.718-8.305 8.305s3.718 8.305 8.305 8.305c4.581-.013 8.292-3.724 8.305-8.305 0-4.587-3.718-8.305-8.305-8.305zm3.39 5.278c.368-.294.904-.234 1.198.134.295.367.235.904-.133 1.198l-4.189 3.293c-.145.113-.324.173-.508.17-.192.007-.38-.053-.533-.17l-3.462-2.736c-.182-.134-.3-.338-.328-.562-.028-.224.038-.45.182-.624.289-.367.819-.432 1.187-.146l2.954 2.325z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledNotificationSelected);
export default __webpack_public_path__ + "static/media/ScheduledNotificationSelected.812d8f482e860638a0c43b289ed91427.svg";
export { ForwardRef as ReactComponent };